import type { SVGProps } from 'react';
const SvgArchery = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="m8.389 28.918 5.09-5.091 1.698 1.697-5.091 5.09z" />
    <path d="m10.5 14.5 2.625 9.625 7-7 1.75 1.75-7 7L24.5 28.5l7-21z" />
  </svg>
);
export default SvgArchery;
